import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponent } from '@base/base.component';
import { DateHelper } from '@helpers/data-helper';
import { CommissionsSummaryResponse, GetCommissionsSummaryRequest, GetSalesReportQuery, GetSalesReportQueryResponse } from '@models/reports/reports';
import { ReportsService } from '@services/reports.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { PERMITION_CONSORTIUM_SALES_PANEL_READ_DETAILS } from 'src/app/const/permitions';

@Component({
  selector: 'app-summary-commission-reports',
  templateUrl: './summary-commission-reports.component.html',
  styleUrl: './summary-commission-reports.component.scss'
})
export class SummaryCommissionReportsComponent extends BaseComponent implements OnInit {
  public form: FormGroup;
  public startDate: Date;
  public endDate: Date;
  public commissionSummary: CommissionsSummaryResponse[] = [];
  public isLoading: boolean = false;

  public constructor(private readonly _reportsService: ReportsService) {
    super();
  }

  public ngOnInit() {

    this.startDate = DateHelper.yearsAgo(DateHelper.currentDate, 4);
    this.endDate = DateHelper.currentDate;

    this.filter();
  }

  public filter(): void {
    try {
      let params: GetCommissionsSummaryRequest = {
        identifierCode: this.getAccessPoint().identifierCode,
        startDate: this.startDate,
        endDate: this.endDate
      };

      this.isLoading = true;

      firstValueFrom(this._reportsService.getCommissionSummary(params))
      .then((result) => {
        this.commissionSummary = result;
      })
      .finally(() =>{
        this.isLoading = false;
      })

    } catch(error) {
      this.openDialogError(error)
    }
  }

  public aggregateSales(commissions: CommissionsSummaryResponse[]): number {
    return commissions?.map(s => s.value)?.reduce((agg, v) => agg + v, 0) ?? 0;
  }

}
